import styled from "styled-components";
import { ColorTone, IconSize } from "@enxcs/dap-ui-stratos";

export interface IconRootProps {
  $size: IconSize;
  $tone?: ColorTone;
}

export const IconRoot = styled.svg<IconRootProps>`
  display: block; // The block remove the annoying white space created by the inline svg
  flex-shrink: 0;
  height: ${(props) => props.$size}px;
  width: ${(props) => props.$size}px;

  path {
    fill: ${(props) => props.$tone || "currentColor"};
  }
`;
